<template>
  <b-card>

    <table-component
      :section="'scheduledBox'"
      :detail-url="'scheduledBoxDetail'"
      :columns="columns"
      :show-status-actions="false"
    />

  </b-card>
</template>

<script>
import TableComponent from '@/layouts/components/TableComponent.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    TableComponent,
    BCard,
  },
  data() {
    return {
      columns: [
        {
          label: '#',
          field: 'id',
          type: 'number',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '50px',
        },
        {
          label: 'Page',
          field: 'pageTitle',
        },
        {
          label: 'Box',
          field: 'boxTitle',
        },
        {
          label: 'Period',
          field: 'period',
        },
        {
          label: 'Frequency',
          field: 'frequency',
        },
        {
          label: 'Next Run',
          field: 'nextRun',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss', // expects 2018-03-16
          dateOutputFormat: 'MMM do yyyy HH:mm', // outputs Mar 16th 2018
        },
        {
          label: 'Last Run',
          field: 'lastRun',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSS', // expects 2018-03-16
          dateOutputFormat: 'MMM do yyyy HH:mm', // outputs Mar 16th 2018
        },
        {
          label: 'Last Run Status',
          field: 'lastRunStatus',
        },
      ],
    }
  },
}
</script>
